import React, { lazy, Suspense, useState, useEffect } from "react";
import useValidate from "../hooks/useValidate";

const Welcome = lazy(() => import("./ParkingValidation/Welcome"));
const SelectSite = lazy(() => import("./ParkingValidation/SelectSite"));
const SelectVrm = lazy(() => import("../components/SelectVrm"));
// const ManualCode = lazy(() => import("./ParkingValidation/ManualCode"));
const QrReaderWrapper = lazy(() => import("./ParkingValidation/QrReaderWrapper"));
const Validating = lazy(() => import("../components/Validating"));
const Success = lazy(() => import("./ParkingValidation/Success"));
const Fail = lazy(() => import("./ParkingValidation/Fail"));

const renderLoader = () => <p>loading</p>;

const ParkingValidation = () => {
  // const [showSplashScreen, setShowSplashScreen] = useState(true);
  const { validate, response } = useValidate();
  const [step, setStep] = useState(0);
  const [selectedSite, setSelectedSite] = useState<any>();
  const [vrm, setVrm] = useState("");
  const [code, setCode] = useState("");

  const startAgain = () => {
    setStep(0);
    setSelectedSite(null);
    setVrm("");
    setCode("");
  };

  const incrementStep = () => {
    setStep(step + 1);
  };

  const codeReceived = (newCode) => {
    if (newCode && newCode !== "") {
      setCode(newCode);
      beginValidate(newCode);
    }
  };

  // Send ajax request to api
  const beginValidate = async (code) => {
    try {
      setStep(step + 1);
      let values = { siteId: selectedSite.value, vrm: vrm, code: code };
      await validateRequest(values);
    } catch (err) {}
  };

  const validateRequest = async (values) => {
    try {
      await validate(values);
    } catch (err) {
      setStep(6);
    }
  };

  // Executes when the validate ajax request completes and the response updates
  useEffect(() => {
    if (step !== 4) return; // only do this if we're in validating mode

    if (response && response.success === true) {
      setStep(5); // show success page
    } else {
      setStep(6); // show fail page
    }
  }, [response]);

  return (
    <Suspense fallback={renderLoader()}>
      {/* {step === 0 && <Success next={startAgain} data={{ overstayed: true }} /> } */}
      {step === 0 && <Welcome next={incrementStep} />}
      {step === 1 && <SelectSite next={incrementStep} onChange={setSelectedSite} disabled={selectedSite == null} />}
      {step === 2 && <SelectVrm next={incrementStep} onChange={setVrm} disabled={vrm === ""} />}
      {/* {step === 3 && <ManualCode next={codeReceived} onChange={setCode} disabled={code === ""} />} */}
      {step === 3 && <QrReaderWrapper onChange={codeReceived} />}
      {step === 4 && <Validating next={incrementStep} />}
      {step === 5 && <Success next={startAgain} data={response} />}
      {step === 6 && <Fail message={response.message} code={response.errorCode} next={startAgain} />}
    </Suspense>
  );
};

export default ParkingValidation;
